import type { Modifier } from '@dnd-kit/core'

/**
 * Keeps a dragged row in its column: the row follows the pointer up and down
 * only, so dragging sideways can't push it past the list's edge and widen it.
 */
export const restrictToVerticalAxis: Modifier = ({ transform }) => ({ ...transform, x: 0 })
